import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from '@apollo/client';


const GET_RECORDINGS_STATE = gql`
  query GetRecordingsState($ids: [String!]) {
    getRecordings(ids: $ids) {
      _id
      state
    }
  }
`;

const useUpToDateRecordingState = (recording) => {
  console.log("useUpToDateRecordingState", recording);
  const { data } = useQuery(GET_RECORDINGS_STATE, { pollInterval: 10000, variables: { ids: [recording._id] }, skip: !recording._id });
  const result = useMemo(() => {
    if (!data)
      return recording;
    console.log("data", data);
    const recordings = data.getRecordings;
    if (!recordings)
      return recording;
    const updatedRecording = recordings.find(r => r._id === recording._id);
    if (!updatedRecording)
      return recording;
    console.log("updatedRecording", updatedRecording);
    return { ...recording, state: updatedRecording.state };
  }, [data, recording]);
  return result;
}

export default useUpToDateRecordingState;